export default function SubCategory(){
    return(
        <section>SubCategory</section>
    );
}